import { traducirError, useTraduccion } from '@tallerya/i18n';
import { AvisoError, Boton, Ventana } from '@tallerya/ui';
import { useState } from 'react';
import { useCambiosItem, version, type FichaItem } from './datos';

// «Editar servicio (Desactivar)» del Figma (#113): la confirmación antes de
// desactivar, desde la edición y desde el menú de la fila del listado. Dice en
// cuántas órdenes está el ítem —lo trae la ficha (#109)— y aclara que esas
// órdenes no cambian, que es justo lo que preocupa a quien está por apretar el
// botón.
//
//   ¿Desactivar este servicio?
//   «Cambio de pastillas de freno» dejará de aparecer…
//   ┌────────────────────────────────────────┐
//   │ Está registrado en 12 órdenes.          │   la caja gris, solo con órdenes
//   │ Esas órdenes no cambian: …              │
//   └────────────────────────────────────────┘
//   Puedes volver a activarlo…                    la nota, en chico
//                          [Cancelar] [Sí, desactivar]

interface Props {
  ficha: FichaItem | null;
  onCerrar: () => void;
  onDesactivado: () => void;
}

export function DesactivarItem({ ficha, onCerrar, onDesactivado }: Props) {
  const { t } = useTraduccion();
  const cambios = useCambiosItem();
  const [enCurso, setEnCurso] = useState(false);
  const [rechazo, setRechazo] = useState<string | null>(null);

  if (!ficha) return null;

  const servicio = ficha.kind === 'service';
  const ordenes = Number(ficha.orderCount);

  async function confirmar() {
    if (!ficha) return;
    setEnCurso(true);
    setRechazo(null);
    try {
      const problema = await cambios.cambiarEstado(String(ficha.id), version(ficha.version), false);
      if (problema) {
        setRechazo(problema.code ? traducirError(problema.code, t) : t('admin.catalogo.error.reintentar'));
        return;
      }
      onDesactivado();
    } catch {
      setRechazo(t('admin.catalogo.error.reintentar'));
    } finally {
      setEnCurso(false);
    }
  }

  return (
    <Ventana
      abierta
      titulo={servicio ? t('admin.catalogo.desactivar.tituloServicio') : t('admin.catalogo.desactivar.tituloProducto')}
      descripcion={t('admin.catalogo.desactivar.texto', { nombre: ficha.name })}
      acciones={
        <>
          <Boton variante="secundario" disabled={enCurso} onClick={onCerrar}>
            {t('admin.catalogo.desactivar.cancelar')}
          </Boton>
          <Boton variante="peligro" disabled={enCurso} aria-busy={enCurso} onClick={() => void confirmar()}>
            {t('admin.catalogo.desactivar.confirmar')}
          </Boton>
        </>
      }
    >
      {/* Sin órdenes no hay nada que aclarar sobre ellas. */}
      {ordenes > 0 && (
        <div className="confirmar__caja">
          <strong>
            {ordenes === 1
              ? t('admin.catalogo.desactivar.unaOrden')
              : t('admin.catalogo.desactivar.ordenes', { n: ordenes })}
          </strong>
          <p>{t('admin.catalogo.desactivar.ordenesNoCambian')}</p>
        </div>
      )}
      <p className="confirmar__nota">{t('admin.catalogo.desactivar.reactivar')}</p>
      {rechazo && <AvisoError aviso={{ titulo: t('admin.catalogo.error.titulo'), texto: rechazo }} />}
    </Ventana>
  );
}
